module.exports = __webpack_public_path__ + "img/06.fff23e69.jpg";